import React, { PureComponent, useCallback, useEffect, useMemo, useState } from "react";

import Box from "@mui/material/Box";

import logoWithTextSrc from "root/img/logo/logo-with-black-text.svg";

const LogoForCharts = ({ sx, width = "147px", ...rest }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "end",
        opacity: "0.3",
        ...sx,
      }}
      {...rest}
      >
      <img width={width} src={logoWithTextSrc} alt="logo" />
    </Box>
  );
};
export default LogoForCharts;
